import {useContext, useState} from 'react';
import PageBuilder from "../../components/panel/PageBuilder";
import {Button, Modal, Table} from "antd";
import {Elements} from "@stripe/react-stripe-js";
import PaymentCard from "./PaymentCard";
import {DeleteOutlined, PlusOutlined} from "@ant-design/icons";
import {ModalConfirmContext} from "../../providers/ModalConfirmProvider";
import {PaymentCardIDType, PaymentCardType} from "../../api/paymentApi";
import {loadStripe} from "@stripe/stripe-js";
import toast from "react-hot-toast";
import {v4 as uuid} from "uuid";

const pk = "pk_test_51Lad7RJljFGz6zFkVYPwW9hbTV2bVQTbDdWLf2ttCAZX0SCmjPC28cC8dewkEXMR6u4rEXnbnAw2AQzMNjJK5PuQ00Rmbu1qt4"
const stripePromise = loadStripe(pk)

type PaymentProps = {
    deleteCard: ({id}: PaymentCardIDType) => Promise<any>
    addCard: ({id}: PaymentCardIDType) => Promise<any>
    isLoadingAddCard: boolean
    isLoadingCards: boolean
    refetchCards: () => void
    cards: PaymentCardType[]
}

const Payment = (
    {
        deleteCard,
        addCard,
        isLoadingAddCard,
        isLoadingCards,
        refetchCards,
        cards,
    }: PaymentProps
) => {
    const {showModal} = useContext(ModalConfirmContext)

    const [isModalOpenAddCard, setIsModalOpenAddCard] = useState(false)

    const columns = [
        {
            title: 'Brand',
            dataIndex: 'brand',
            key: 'brand'
        },
        {
            title: 'Last 4',
            dataIndex: 'last4',
            key: 'last4'
        },
        {
            title: 'Exp Month',
            dataIndex: 'exp_month',
            key: 'exp_month'
        },
        {
            title: 'Exp Year',
            dataIndex: 'exp_year',
            key: 'exp_year'
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_: void, card: PaymentCardType) => (
                <>
                    <Button
                        onClick={() => {
                            const handleDelete = async () => {
                                const loader = toast.loading("Progressing...");
                                const res = await deleteCard({id: card.id})
                                toast.dismiss(loader);
                                if ('error' in res) return
                                toast.success('Payment Method is successfully deleted!')
                                refetchCards()
                            }

                            showModal('delete payment card', handleDelete)
                        }}
                        type="link"
                        size="small">
                        <DeleteOutlined/>
                    </Button>
                </>
            )
        }
    ]

    const handleAddCard = async (id: string) => {
        const res = await addCard({id})
        if ('error' in res) return
        toast.success('Payment Method is successfully added!')
        setIsModalOpenAddCard(false)
        refetchCards()
    }

    return (
        <PageBuilder title='Payment' documentTitle='Payment'>
            <div style={{marginBottom: 20}}>
                <Button type="primary" onClick={() => setIsModalOpenAddCard(true)}>
                    <PlusOutlined/> Add Payment Card
                </Button>
            </div>

            <Table rowKey={() => uuid()} loading={isLoadingCards} pagination={false} dataSource={cards}
                   columns={columns}/>

            {
                isModalOpenAddCard && (
                    <Modal
                        title="Add Payment Card"
                        open={isModalOpenAddCard}
                        onCancel={() => setIsModalOpenAddCard(false)}
                        footer={null}
                    >
                        <Elements stripe={stripePromise}>
                            <PaymentCard isLoading={isLoadingAddCard} addCard={handleAddCard}/>
                        </Elements>
                    </Modal>

                )}
        </PageBuilder>
    );
};

export default Payment;
